export default function Copyright() {
  return (
    <i className="copyright">
      Copyright: masterclass_005
      <br />
      @2022
    </i>
  );
}
